import React, { useEffect, useState } from 'react';

import { TListingClient } from 'types/TListing';

type TBiddingAppProps = {
  appState: {
    listing: {
      bidsInfo: TListingClient['bidsInfo'];
      itemId: TListingClient['itemId'];
      title: TListingClient['title'];
      seller: TListingClient['seller'];
      priceInfo: TListingClient['priceInfo'];
      isCarAd: TListingClient['isCarAd'];
      isReserved: TListingClient['isReserved'];
      flags: TListingClient['flags'];
    };
  };
};

let Bidding;

const BiddingApp = ({ appState }: TBiddingAppProps) => {
  const {
    listing: {
      bidsInfo,
      itemId,
      title,
      seller: { name },
      priceInfo: { priceType },
      isCarAd,
      isReserved,
    },
  } = appState;
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (bidsInfo.isBiddingEnabled) {
      const loadComponent = async () => {
        try {
          Bidding = (await import(/* webpackChunkName: "bidding" */ './components/Bidding/Bidding')).default;
          setIsLoaded(true);
        } catch {}
      };

      loadComponent();
    }
  }, [bidsInfo.isBiddingEnabled]);

  if (!isLoaded) {
    return null;
  }

  return (
    <Bidding
      bidsInfo={bidsInfo}
      itemId={itemId}
      title={title}
      sellerName={name}
      priceType={priceType}
      withPhoneNumber={isCarAd}
      isReserved={isReserved}
    />
  );
};

export default BiddingApp;
